import React from "react";
import PixelTypeColor from "../../interfaces/cleaning-map/pixel-color-type";
import { getPointInObstacleCoords } from "./ActiveZonesCanvas";
import PlannedPath from "../../interfaces/cleaning-map/planned-path";
import MapInfo from "../../interfaces/cleaning-map/map-info";

const PlannedPathSvgComponent: React.FC<{ plannedPath: PlannedPath; primaryMapInfo: MapInfo }> = ({
  plannedPath,
  primaryMapInfo,
}) => {
  if (plannedPath.poses == null) return null;

  return (
    <polyline
      points={plannedPath.poses
        .slice(plannedPath.poses!.length - plannedPath.length)
        .map((pose) => {
          const posePoint = getPointInObstacleCoords(pose.coordinateX, pose.coordinateY, primaryMapInfo, true);
          return `${posePoint.coordinateX},${posePoint.coordinateY}`;
        })
        .join(" ")}
      fill="none"
      stroke={`rgb(${PixelTypeColor.PlannedPath})`}
      strokeWidth={0.5}
    />
  );
};

const PlannedPathSvg = React.memo(PlannedPathSvgComponent);

export default PlannedPathSvg;
